import type { ProductPrice } from 'graphql/types/graphql'
import type { ProductBadges } from '~/components/Shc/Ui/Product/Badges/productBadges'

export interface ProductParam {
    brand: string
    brandLabel: string
    id: number
    sku: string
    name: string
    productPrice: ProductPrice
    categoryId?: number
    categoryName?: string
    parentCategoryId?: number
    parentCategoryName?: string
    dlCategoryIdentifier?: string
    dlCategoryName?: string
    dlParentCategoryIdentifier?: string
    dlParentCategoryName?: string
    shopName?: string
    productBadges: ProductBadges
    productFlags: ProductBadges
    quantity
    dataLayer?: {
        topCategoryId: string
        topCategoryName: string
        fullCategoryString: string
    }
}

export function getProductForGtm(product: ProductParam, quantity?: number) {
    const { BRAND_BBK } = useAppConfig()
    const {
        brand,
        brandLabel,
        id,
        sku,
        name,
        quantity: groupedQuantity,
        productPrice: { finalPrice, regularPrice } = { finalPrice: { value: 0 }, regularPrice: { value: 0 } },
        categoryId,
        categoryName,
        parentCategoryId,
        parentCategoryName,
        dlCategoryIdentifier,
        dlCategoryName,
        dlParentCategoryIdentifier,
        dlParentCategoryName,
        shopName,
        productBadges,
        productFlags,
    } = product

    const labels = productBadges ? productBadges?.map((item) => item.label) : productFlags?.map((item) => item.label)

    return {
        productId: id,
        id: sku as unknown as number,
        name,
        brand: brandLabel || brand,
        quantity: groupedQuantity || quantity,
        seller: shopName || BRAND_BBK,
        price: finalPrice?.value ?? 0,
        priceCatalog: regularPrice?.value ?? 0,
        categoryId: categoryId || dlCategoryIdentifier || '',
        categoryName: categoryName || dlCategoryName || '',
        parentCategoryId: parentCategoryId || dlParentCategoryIdentifier || '',
        parentCategoryName: parentCategoryName || dlParentCategoryName || '',
        variant: '',
        labels: labels ? labels.join(';') : '',
        topCategoryId: product.dataLayer?.topCategoryId,
        topCategoryName: product.dataLayer?.topCategoryName,
        fullCategoryString: product.dataLayer?.fullCategoryString,
    } as ProductBaseGtm
}
